import React, { useEffect } from 'react';
import Layout from '@/common/Layout';
import Settings from './components/Settings';
import { useDispatch, useSelector } from 'react-redux';
import { countryCodes } from '../Registration/redux/slice';
import { getAccountSettings } from './redux/slice';

const index = () => {
  useEffect(() => {
    document.title = 'Account Settings - Privacy & Preferences';
  }, []);

  const dispatch = useDispatch();

  const { country_codes } = useSelector((state) => state.registrations);
  const { Settings_user, sendrequestLoading } = useSelector(
    (state) => state.settings
  );
  // console.log('Settings_user', Settings_user);
  useEffect(() => {
    get_countryCodes();
    get_account_settings();
  }, []);

  const get_countryCodes = () => {
    dispatch(countryCodes());
  };

  const get_account_settings = () => {
    dispatch(getAccountSettings());
  };

  return (
    <>
      <Layout sider={true}>
        <Settings
          country_codes={country_codes}
          Settings_user={Settings_user}
          sendrequestLoading={sendrequestLoading}
        />
      </Layout>
    </>
  );
};

export default index;
